import React from "react";

const Card = ({ header, description, icon, alttext }) => {
  return (
    <div className="card">
      <div className="grid card__image">
        <img src={icon} title={header} height="65" width="68" alt={alttext} />
      </div>
      <div className="card-content">
        <div className="media">
          <div className="media-content">
            <p className="title is-5 has-text-centered">{header}</p>
          </div>
        </div>
        <div className="content">
          <p className="has-text-centered	">{description}</p>
          <br />
        </div>
      </div>
      {/* <footer className="card-footer">
        <a className="button is-primary  is-fullwidth">iletişim</a>
      </footer> */}
    </div>
  );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/common/Card.js